import { ICoffeeLeadIssueView } from '../../../../../extViewmodels';
import { LoadingSpinner } from '../../../../../web/components/LoadingSpinner';
import { styleSheet } from '../styles';
import { ListItem } from './ListItem';
import { css } from 'aphrodite';
import * as React from 'react';

interface IProps {
	isLoading?: boolean;
	items: ICoffeeLeadIssueView[];
	onMarkComplete?: (issueId: string) => void;
}

export const ListItemsContainer: React.FC<IProps> = ({ isLoading, items, onMarkComplete }) => {
	return (
		<>
			{isLoading ? (
				<LoadingSpinner type='large' className={css(styleSheet.loadingSpinner)} />
			) : items?.length > 0 ? (
				items.map(item => {
					return <ListItem key={item.id} item={item} onMarkComplete={onMarkComplete} />;
				})
			) : (
				<div className={css(styleSheet.emptyState)}>No issues found.</div>
			)}
		</>
	);
};
